/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var GooglePlusGIcon = createIcon({
  name: 'GooglePlusGIcon',
  height: 512,
  width: 640,
  svgPath: 'M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default GooglePlusGIcon;